module.exports = __webpack_public_path__ + "static/media/Desgaste.89c982c2.png";